import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../components/Home/Home.vue'
import Admin from '../components/Admin/Admin.vue'
import Detail from '../components/Detail/Detail.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/alle'
  },
  {
    path: '/kluis',
    name: 'Kluis',
    component: Admin
  },
  {
    path: '/:category',
    name: 'Home',
    component: Home,
    props: true
  },
  {
    path: '/:category/:page',
    name: 'Detail',
    component: Detail,
    props: true
  },
  {
    path: '*',
    redirect: '/alle'
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
